var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircleTruckIcon = function SvgCircleTruckIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30,
    fill: "white",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6333 43.2559C16.6333 40.9009 18.487 39.0117 20.7333 39.0117C22.9796 39.0117 24.8333 40.9009 24.8333 43.2559C24.8333 45.6108 22.9796 47.5001 20.7333 47.5001C18.487 47.5001 16.6333 45.6108 16.6333 43.2559ZM17.1667 43.2559C17.1667 45.2616 18.7514 46.9186 20.7333 46.9186C22.7151 46.9186 24.2999 45.2616 24.2999 43.2559C24.2999 41.2502 22.7151 39.5931 20.7333 39.5931C18.7515 39.5931 17.1667 41.2501 17.1667 43.2559Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7 43.2559C42.7 40.9009 44.5536 39.0117 46.8 39.0117C49.0463 39.0117 50.9 40.9009 50.9 43.2559C50.9 45.6108 49.0463 47.5001 46.8 47.5001C44.5536 47.5001 42.7 45.6108 42.7 43.2559ZM43.2333 43.2559C43.2333 45.2616 44.8181 46.9186 46.8 46.9186C48.7819 46.9186 50.3666 45.2616 50.3666 43.2559C50.3666 41.2502 48.7819 39.5931 46.8 39.5931C44.8182 39.5931 43.2333 41.2501 43.2333 43.2559Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4537 34.3949L55.4544 34.396C55.4832 34.4418 55.4999 34.4988 55.4999 34.5578V34.5581V43.2558C55.4999 43.4316 55.3666 43.5465 55.2332 43.5465H51.1332V42.9651H54.4666H54.9666V42.4651V34.7906V34.6475L54.8909 34.5261L48.339 24.0146L48.1922 23.7791H47.9146H40.6666H40.1666V24.2791V42.4649V42.9649H40.6666H42.4666V43.5464H39.8999C39.7665 43.5464 39.6333 43.4315 39.6333 43.2557V23.4883C39.6333 23.313 39.7669 23.1977 39.8999 23.1977H48.3332C48.4167 23.1977 48.5015 23.2415 48.5537 23.3251C48.5537 23.3251 48.5537 23.3252 48.5538 23.3252L55.4537 34.3949Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7335 26.9419H43.2335V27.4419V32.4766V32.9766V32.9767H43.7335V33.4766H53.9668V34.058H42.9668C42.8334 34.058 42.7002 33.9431 42.7002 33.7674V26.6511C42.7002 26.4758 42.8338 26.3604 42.9668 26.3604H49.3668V26.9419H43.7335Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0334 42.465V42.965H11.5334H16.4V43.5465H10.7666C10.6337 43.5465 10.5 43.4312 10.5 43.2558V17.9535C10.5 17.7785 10.634 17.6628 10.7666 17.6628H39.9C40.0331 17.6628 40.1667 17.7782 40.1667 17.9535V43.2558C40.1667 43.4316 40.0334 43.5465 39.9 43.5465H25.0667V42.965H39.1334H39.6334V42.465V18.7441V18.2441H39.1334H11.5334H11.0334V18.7441V42.465Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2666 39.8023H14.8666V40.3837H11.2666V39.8023Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 39.8023H38.6334V40.3837H26.6V39.8023Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6669 39.8023H54.7335V40.3837H52.6669V39.8023Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9865 21.3H38.8199V21.8814H12.9865V21.3Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4667 42.9651H21V43.5465H20.4667V42.9651Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5334 42.9651H47.0668V43.5465H46.5334V42.9651Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5668 14.5H23.3001V15.0814H13.5668V14.5Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5H11.0334V15.0814H10.5V14.5Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleTruckIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CircleTruckIcon.090d1573.svg";
export { ForwardRef as ReactComponent };